import {
  Home,
  Users,
  Calendar,
  Trophy,
  ClipboardList,
  Star,
  User,
  MessageSquare,
  UserPlus,
  Award,
  Megaphone,
  Wallet,
  DoorOpen,
  Dock,
  ClipboardPaste,
  LayoutTemplate,
  FolderOpen,
  ListChecks,
} from "lucide-react";

const GENSEC_COMMON_NAV = [
  { key: "dashboard", label: "Home", icon: Home },
  // { key: "cosa", label: "CoSA", icon: Users },
  { key: "announcements", label: "Announcements", icon: Megaphone },
  { key: "students", label: "Students", icon: Users },
  { key: "events", label: "Events", icon: Calendar },
  { key: "roombooking", label: "RoomBooking", icon: DoorOpen },
  { key: "endorsement", label: "Endorsements", icon: Award },
  { key: "feedback", label: "Feedback", icon: ClipboardList },
  { key: "tasks", label: "Tasks", icon: ListChecks },
  // { key: "add-event", label: "Add Event", icon: Plus },
  { key: "por", label: "PORs", icon: UserPlus },
  { key: "budget", label: "Budget", icon: Wallet },
  { key: "profile", label: "Profile", icon: User },
  { key: "requests", label: "Requests", icon: ClipboardPaste },
  { key: "organization", label: "Clubs", icon: Users },
  { key: "tenure", label: "Tenure", icon: Users },
];

export const NavbarConfig = {
  PRESIDENT: [
    { key: "dashboard", label: "Home", icon: Home },
    // { key: "cosa", label: "CoSA", icon: Users },
    { key: "announcements", label: "Announcements", icon: Megaphone },
    { key: "students", label: "Students", icon: Users },
    { key: "por", label: "PORs", icon: UserPlus },
    { key: "budget", label: "Budget", icon: Wallet },
    { key: "feedback", label: "Feedback", icon: ClipboardList },
    { key: "tasks", label: "Tasks", icon: ListChecks },
    { key: "events", label: "Events", icon: Calendar },
    { key: "roombooking", label: "RoomBooking", icon: DoorOpen },
    // { key: "add-event", label: "Add Event", icon: Plus },
    { key: "profile", label: "Profile", icon: User },
    { key: "requests", label: "Requests", icon: ClipboardPaste },
    { key: "organization", label: "Clubs", icon: Users },
    { key: "tenure", label: "Tenure", icon: Users },
  ],
  GENSEC_SCITECH: GENSEC_COMMON_NAV,
  GENSEC_ACADEMIC: GENSEC_COMMON_NAV,
  GENSEC_CULTURAL: GENSEC_COMMON_NAV,
  GENSEC_SPORTS: GENSEC_COMMON_NAV,

  CLUB_COORDINATOR: [
    { key: "dashboard", label: "Home", icon: Home },

    // { key: "cosa", label: "CoSA", icon: Users },
    { key: "announcements", label: "Announcements", icon: Megaphone },

    { key: "por", label: "PORs", icon: UserPlus },
    { key: "budget", label: "Budget", icon: Wallet },
    { key: "events", label: "Events", icon: Calendar },
    { key: "roombooking", label: "RoomBooking", icon: DoorOpen },
    // { key: "add-event", label: "Add Event", icon: Plus },
    { key: "feedback", label: "Feedback", icon: ClipboardList },
    { key: "tasks", label: "Tasks", icon: ListChecks },
    { key: "profile", label: "Profile", icon: User },
    { key: "batches", label: "Batches", icon: FolderOpen },
    { key: "templates", label: "Templates", icon: LayoutTemplate },
    { key: "endorsement", label: "Endorsements", icon: Award },
    { key: "tenure", label: "Tenure", icon: Users },
  ],

  STUDENT: [
    { key: "dashboard", label: "Home", icon: Home },
    { key: "announcements", label: "Announcements", icon: Megaphone },

    { key: "profile", label: "Profile", icon: User },
    // { key: "cosa", label: "CoSA", icon: Users },
    { key: "certificates", label: "Certificates", icon: Dock },
    { key: "events", label: "Events", icon: Calendar },
    { key: "feedback", label: "Feedback", icon: MessageSquare },
    { key: "tasks", label: "Tasks", icon: ListChecks },
    // { key: "view-feedback", label: "Feedback", icon: ClipboardList },
    { key: "achievements", label: "Achieve", icon: Trophy },
    // { key: "view-achievements", label: "View Achievements", icon: Trophy },
    { key: "skills", label: "Skills", icon: Star },
    { key: "por", label: "PORs", icon: ClipboardList },
    { key: "tenure", label: "Tenure", icon: Users },
  ],
};
